const ENV = process.env.REACT_APP_ENV || "development";

const CONFIG = {
  // Used by the dockerised local stack — see `integral-stack/RULES.md`
  // → "Jantro stack". BFF runs on :5002 (canvas owns :5001), project-id
  // "jantro-local" matches the JANTRO_ENVIRONMENT the BFF starts with.
  // Auth middleware is bypassed in this mode (see `functions/index.js`).
  "local-container": {
    googleAuthClientId: "615517163909-8gee6c8v7omisui4mrlmphn07hkt04q4.apps.googleusercontent.com",
    apiBaseUrl: "http://localhost:5002/jantro-local/europe-west3/api",
    sidebarWidthPx: 265,
  },
  development: {
    googleAuthClientId: "615517163909-8gee6c8v7omisui4mrlmphn07hkt04q4.apps.googleusercontent.com",
    apiBaseUrl: "http://127.0.0.1:5001/jantro-prod/europe-west3/api",
    sidebarWidthPx: 265,
  },
  stage: {
    googleAuthClientId: "615517163909-8gee6c8v7omisui4mrlmphn07hkt04q4.apps.googleusercontent.com",
    apiBaseUrl: "https://api-3ahtvk3g2q-ey.a.run.app",
    sidebarWidthPx: 265,
  },
  prod: {
    googleAuthClientId: "962980575897-uq3i5dtcjvhpbe926fes7imlq9fqohnl.apps.googleusercontent.com",
    apiBaseUrl: "https://api-4wuhdlaguq-ey.a.run.app",
    sidebarWidthPx: 265,
  },
  "prod-integral-audit": {
    googleAuthClientId: "381651328380-hscrebuirbstma10l1qe39cua82ksu0k.apps.googleusercontent.com",
    apiBaseUrl: "https://api-bo6hdbrera-ey.a.run.app",
    sidebarWidthPx: 265,
  },
};

export default CONFIG[ENV];
